import { useMemo } from 'react';
import getThemeConfigurations from '.';
import { createTheme } from '@mui/material';

import useLocalStorageState from '@app/hooks/useLocalStorageState';
import { buildEventBusEffect, EventBusFactory } from '@utilities/event-bus';

const eventBus = EventBusFactory.resolve('global');
const useBusEffectOn = buildEventBusEffect(eventBus);

export default function withApplicationTheme(Application) {
  return function (props) {
    const { dispatch } = eventBus;
    const [mode, setMode] = useLocalStorageState('theme-mode', 'light');

    const toggleMode = pre => {
      const newMode = pre === 'dark' ? 'light' : 'dark';
      dispatch('theme-mode-changed', newMode);
      return newMode;
    };

    useBusEffectOn('toggle-theme-mode', () => setMode(pre => toggleMode(pre)));
    useBusEffectOn('change-theme-mode', newMode => {
      if (['dark', 'light'].includes(newMode)) setMode(newMode);
    });
    const theme = useMemo(() => createTheme(getThemeConfigurations(mode)), [mode]);

    return <Application {...props} theme={theme} />;
  };
}
